/*
 * @Author: your name
 * @Date: 2021-09-01 16:17:25
 * @LastEditTime: 2021-10-12 20:46:35
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lwdgis-ui\src\V3\js\mapStyle.js
 */
import 'ol/ol.css'
import { Circle, Stroke, Style, Fill, Icon, Text } from 'ol/style'
function line_style(labelText) {
    // 1911年甘肃省政区边界
    this.county_old = new Style({
        stroke: new Stroke({
            color: '#BD3930',
            width: 3,
            // lineDash: [20, 10, 40, 20],
            // linecap: 'square',
            // linejoin: 'bevel',
        }),

        text: new Text({   // 字体样色
            text: labelText,
            font: '17px Calibri, 微软雅黑',
            backgroundStroke: new Stroke({
                color: '#000',
                width: 1
            }),
            //标签的背景填充
            backgroundFill: new Fill({
                color: '#FFFFFF'
            }),
            fill: new Fill({
                color: '#000'
            }),

            offsetX: 40
        })

    });
    this.county_old1 = new Style({
        stroke: new Stroke({
            color: '#B53C48',
            width: 2,
            // lineDash: [20, 10, 40, 20],
            // linecap: 'square',
            // linejoin: 'bevel',
        }),

        text: new Text({   // 字体样色
            text: labelText,
            font: '17px Calibri, 微软雅黑',
            backgroundStroke: new Stroke({
                color: '#000',
                width: 1
            }),
            //标签的背景填充
            backgroundFill: new Fill({
                color: '#FFFFFF'
            }),
            fill: new Fill({
                color: '#000'
            }),

            offsetX: 40
        })

    });
    this.county_old2 = new Style({
        stroke: new Stroke({
            color: '#AA3E64',
            width: 1,
            // lineDash: [20, 10, 40, 20],
            // linecap: 'square',
            // linejoin: 'bevel',
        }),

        text: new Text({   // 字体样色
            text: labelText,
            font: '17px Calibri, 微软雅黑',
            backgroundStroke: new Stroke({
                color: '#000',
                width: 1
            }),
            //标签的背景填充
            backgroundFill: new Fill({
                color: '#FFFFFF'
            }),
            fill: new Fill({
                color: '#000'
            }),

            offsetX: 40
        })

    });
        // 1911年甘肃省政区边界
    this.gmodern = new Style({
            stroke: new Stroke({
                color: '#E7E7E7',
                width: 1,
                // lineDash: [20, 10, 40, 20],
                // linecap: 'square',
                // linejoin: 'bevel',
            }),
    
            text: new Text({   // 字体样色
                text: labelText,
                font: '17px Calibri, 微软雅黑',
                backgroundStroke: new Stroke({
                    color: '#000',
                    width: 1
                }),
                //标签的背景填充
                backgroundFill: new Fill({
                    color: '#FFFFFF'
                }),
                fill: new Fill({
                    color: '#000'
                }),
    
                offsetX: 40
            })
    
        });

}
function plane_style(labelText) {
    //现代甘肃省市级政区边界
    this.county_now = new Style({
        stroke: new Stroke({
            color: '#FFE793',
            width: 3,
            lineDash: [20, 10, 40, 20],
        }),
        fill: new Fill({
            color: 'rgba(0, 0, 255, 0)'    //填充颜色，不透明度0
        }),
        text: new Text({   // 字体样色
            text: labelText,
            font: '17px Calibri, 微软雅黑',

            fill: new Fill({
                color: '#fff'
            }),
            stroke: new Stroke({
                width: 1
            }),
            offsetX: 40
        })

    });
    // 缩放到县图层
    this.prefecture_seat_tranparent = new Style({
        stroke: new Stroke({
            color: 'rgba(0, 0, 255, 0)',
            width: 0
        }),
        fill: new Fill({
            color: 'rgba(0, 0, 255, 0)'    //填充颜色，不透明度0
        }),


    });
    this.selPolygon = new Style({
        stroke: new Stroke({
            color: '#000',
            width: 0
        }),
        fill: new Fill({
            color: 'rgba(0, 0, 255, 0)'    //填充颜色，不透明度0
        }),
        text: new Text({   // 字体样色
            text: labelText,
            font: '30px Calibri, 微软雅黑',
            fill: new Fill({
                color: '#d71345'
            }),
        })

    });

}
function point_style(labelText) {
    // 1911年省级政区治所
    this.province_seat = new Style({
        // image: new Circle({
        //     radius: 8,
        //     fill: new Fill({
        //         color: '#FFE793'
        //     })
        // }),
        image: new Icon({
            src: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(` <svg
            t="1640693754610"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="22948"
            width="28"
            height="28"
            x="16"
            y="13"
        >
            <path
                d="M512 949.138286c238.72 0 437.138286-197.997714 437.138286-437.138286 0-238.72-198.857143-437.138286-437.577143-437.138286C272.438857 74.861714 74.88 273.28 74.88 512c0 239.140571 197.997714 437.138286 437.138286 437.138286z m0-72.850286C309.705143 876.288 148.114286 714.276571 148.114286 512c0-201.874286 161.152-364.288 363.446857-364.288 201.856 0 364.269714 162.432 364.708571 364.288 0.420571 202.294857-162.432 364.288-364.288 364.288z m-0.420571-86.144c151.698286 0 277.705143-125.988571 277.705142-277.723429 0-152.137143-126.427429-278.125714-277.723428-278.125714-152.137143 0-277.705143 125.988571-277.705143 278.125714 0 151.716571 125.988571 277.723429 277.723429 277.723429z"
                p-id="22949"
                fill="#BA8B02"
            ></path>
        </svg>`)
        }),

        text: new Text({   // 字体样色
            text: labelText,
            font: '17px Calibri, 微软雅黑',
            backgroundStroke: new Stroke({
                color: '#5B5E62',
                width: 1
            }),
            //标签的背景填充
            backgroundFill: new Fill({
                color: '#FFFFFF'
            }),
            fill: new Fill({
                color: '#000'
            }),

            offsetX: 40
        }),
        zIndex:2000
    });
    // 1911年府级治所
    this.county_seat_label1= new Style({
        // image: new Circle({
        //     radius: 3,
        //     fill: new Fill({
        //         color: '#FFE793'
        //     }),
        // }),
        image: new Icon({
            src: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(`<svg t="1667398317704" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3524" width="18" height="18"><path d="M512 64c60.5 0 119.2 11.8 174.4 35.2 53.3 22.6 101.3 54.9 142.4 96 41.2 41.2 73.5 89.1 96 142.4C948.2 392.8 960 451.5 960 512s-11.8 119.2-35.2 174.4c-22.6 53.3-54.9 101.3-96 142.4-41.2 41.2-89.1 73.5-142.4 96C631.2 948.2 572.5 960 512 960s-119.2-11.8-174.4-35.2c-53.3-22.6-101.3-54.9-142.4-96-41.2-41.2-73.5-89.1-96-142.4C75.8 631.2 64 572.5 64 512s11.8-119.2 35.2-174.4c22.6-53.3 54.9-101.3 96-142.4s89.1-73.5 142.4-96C392.8 75.8 451.5 64 512 64m0-64C229.2 0 0 229.2 0 512s229.2 512 512 512 512-229.2 512-512S794.8 0 512 0z" p-id="3525" fill="#BA8B02"></path><path d="M512 192c43.2 0 85.1 8.5 124.5 25.1 38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7C823.5 426.9 832 468.8 832 512s-8.5 85.1-25.1 124.5c-16.1 38.1-39.2 72.3-68.6 101.7-29.4 29.4-63.6 52.5-101.7 68.6C597.1 823.5 555.2 832 512 832s-85.1-8.5-124.5-25.1c-38.1-16.1-72.3-39.2-101.7-68.6-29.4-29.4-52.5-63.6-68.6-101.7C200.5 597.1 192 555.2 192 512s8.5-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 200.5 468.8 192 512 192m0-64c-212.1 0-384 171.9-384 384s171.9 384 384 384 384-171.9 384-384-171.9-384-384-384z" p-id="3526" fill="#BA8B02"></path></svg>
		`)
        }),

        text: new Text({   // 字体样色
            text: labelText,
            font: '15px Calibri, 微软雅黑',
            // backgroundStroke: new Stroke({
            //     color: '#000',
            //     width: 1
            // }),
            //标签的背景填充
            // backgroundFill: new Fill({
            //     color: '#fff'
            // }),
            fill: new Fill({
                color: '#fff'
            }),
            stroke: new Stroke({
                width: 1
            }),
            offsetX: 35
        }),
        zIndex:1000

    });
    //1911年县级政区治所
    this.county_seat_label = new Style({
        // image: new Circle({
        //     radius: 3,
        //     fill: new Fill({
        //         color: '#FFE793'
        //     }),
        // }),
        image: new Icon({
            src: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(`<svg
            t="1640685331995"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="16821"
            width="15"
            height="15"
            x="23"
            y="48"
        >
            <path
                d="M512 949.138286c238.72 0 437.138286-197.997714 437.138286-437.138286 0-238.72-198.857143-437.138286-437.577143-437.138286C272.438857 74.861714 74.88 273.28 74.88 512c0 239.140571 197.997714 437.138286 437.138286 437.138286z m0-72.850286C309.705143 876.288 148.114286 714.276571 148.114286 512c0-201.874286 161.152-364.288 363.446857-364.288 201.856 0 364.269714 162.432 364.708571 364.288 0.420571 202.294857-162.432 364.288-364.288 364.288z m0.420571-238.281143c68.571429 0 125.586286-56.576 125.586286-126.006857 0-68.571429-57.014857-124.708571-125.586286-124.708571-68.992 0-125.988571 56.137143-125.988571 124.708571 0 69.430857 56.996571 125.988571 125.988571 125.988571z"
                p-id="16822"
                fill="#BA8B02"
            ></path>
        </svg>`)
        }),

        text: new Text({   // 字体样色
            text: labelText,
            font: '15px Calibri, 微软雅黑',
            // backgroundStroke: new Stroke({
            //     color: '#000',
            //     width: 1
            // }),
            //标签的背景填充
            // backgroundFill: new Fill({
            //     color: '#fff'
            // }),
            fill: new Fill({
                color: '#fff'
            }),
            stroke: new Stroke({
                width: 1
            }),
            offsetX: 35
        }),
        zIndex:500

    });
    //  白底标注 其他用户定位的数据点
    this.defaultOther = new Style({
        image: new Circle({
            radius: 6,
            fill: new Fill({
                color: '#000'
            })
        }),
        text: new Text({   // 字体样色
            text: labelText,
            font: '17px Calibri, 微软雅黑',
            backgroundStroke: new Stroke({
                color: '#000',
                width: 1
            }),
            //标签的背景填充
            backgroundFill: new Fill({
                color: '#FFFFFF'
            }),
            fill: new Fill({
                color: '#000'
            }),
            offsetX: 40
        })
    });
    //  白底标注 用户自己定位的数据点

    this.default = new Style({
        image: new Circle({
            radius: 6,
            fill: new Fill({
                color: '#FF0000'
            })
        }),
        text: new Text({   // 字体样色
            text: labelText,
            font: '17px Calibri, 微软雅黑',
            backgroundStroke: new Stroke({
                color: '#000',
                width: 1
            }),
            //标签的背景填充
            backgroundFill: new Fill({
                color: '#FFFFFF'
            }),
            fill: new Fill({
                color: '#000'
            }),
            offsetX: 40
        })
    });
    // 高亮
    this.highlight = new Style({
        image: new Circle({
            radius: 12,
            fill: new Fill({
                color: '#FF0000'
            }),
            stroke: new Stroke({
                color: 'yellow',
                width: 6
            }),
        }),
        text: new Text({   // 字体样色
            text: labelText,
            font: '17px Calibri, 微软雅黑',
            backgroundStroke: new Stroke({
                color: '#000',
                width: 1
            }),
            //标签的背景填充
            backgroundFill: new Fill({
                color: '#FFFFFF'
            }),
            fill: new Fill({
                color: '#000'
            }),

            offsetX: 40
        })
    });
}
export {
    line_style, plane_style, point_style
};



// WEBPACK FOOTER //
// ./src/V3/js/mapStyle.js